// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { reaction } from "mobx";
import { Headline } from "../../../components/headline/Headline";
import { Gallery } from "../../../components/gallery/Gallery";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
    Gallery,
    ImageAspectRatio,
  },
})
export class AbhFirmenphilosophieModule extends ModuleBase {
  get bodyBuilder() {
    return this.$store.conversionWorld.bodyBuilder;
  }

  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get isVanSolution() {
    if (
      this.instance["optional"] &&
      (this.instance["optional"]["portrait"].length > 0 ||
        this.instance["optional"]["images"].length > 0)
    ) {
      return this.instance["optional"]["is_vansolution"];
    } else if (this.bodyBuilder) {
      return this.bodyBuilder.type == "vansolution";
    } else {
      return false;
    }
  }

  get headline() {
    return this.instance["translation"]["headline"];
  }

  get philosophie() {
    if (
      this.instance["optional"] &&
      this.instance["optional"]["portrait"].length > 0
    ) {
      return this.instance["optional"]["portrait"];
    } else if (this.bodyBuilder) {
      return this.bodyBuilder.philosophy;
    } else {
      return "";
    }
  }

  get images() {
    if (
      this.instance["optional"]["images"] &&
      this.instance["optional"]["images"].length > 0
    ) {
      return this.instance["optional"]["images"].map((img) => {
        return {
          video: null,
          enlarge: true,
          text: img["title"],
          image: img["image"],
        };
      });
    } else if (this.bodyBuilder) {
      return this.bodyBuilder.additional_images.map((img) => {
        return {
          video: null,
          enlarge: true,
          text: "",
          image: {
            de: img,
          },
        };
      });
    }
  }

  get galleryImages() {
    if (this.isVanSolution) {
      if (this.images.length <= 4) {
        return this.images;
      } else if (this.images.length == 5) {
        return this.images.slice(0, 4);
      } else {
        return this.images.slice(0, 6);
      }
    } else {
      return this.images;
    }
  }
}
